import env from './env';
const handleUnauthenticated = () => {
  alert(
    'You have been logged out because your account was used on another device.',
  );
  localStorage.clear();
  window.location.href = '/';
};

const Post = {
  Login: data => {
    return new Promise((resolve, reject) => {
      fetch(env.Url + 'login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(res => res.json())
        .then(res => {
          if (res && res.api_token) {
            localStorage.setItem('user', JSON.stringify(res));
          }
          if (res.message === 'Unauthenticated.') {
            handleUnauthenticated();
          }
          resolve(res);
        })
        .catch(err => reject(err));
    });
  },
  Otp: data => {
    return new Promise((resolve, reject) => {
      fetch(env.Url + 'verify', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },
  Forgot: data => {
    return new Promise((resolve, reject) => {
      fetch(env.Url + 'forgot', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },
  NewPassword: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user_bkp');
      if (user) {
        fetch(
          env.Url + 'new/password?api_token=' + JSON.parse(user).api_token,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          },
        )
          .then(res => res.json())
          .then(res => {
            console.log(res);
            resolve(res);
          });
      }
    });
  },
  Signup: data => {
    return new Promise((resolve, reject) => {
      fetch(env.Url + 'signup', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(res => res.json())
        .then(res => {
          resolve(res);
        });
    });
  },

  Bidding: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'bedding?api_token=' + JSON.parse(user).api_token, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  Withdraw: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'withdraw?api_token=' + JSON.parse(user).api_token, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(res => res.json())
          .then(res => {
            resolve(res);
          });
      }
    });
  },

  AddMoney: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(env.Url + 'add/money?api_token=' + JSON.parse(user).api_token, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then(res => res.json())
          .then(res => resolve(res));
      }
    });
  },

  ChangePassword: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      if (user) {
        fetch(
          env.Url + 'change/password?api_token=' + JSON.parse(user).api_token,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          },
        )
          .then(res => res.json())
          .then(res => resolve(res));
      }
    });
  },
  harfBetting: data => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem('user');
      console.log(
        env.Url + 'harf?api_token=' + (user ? JSON.parse(user).api_token : ''),
      );
      fetch(
        env.Url + 'harf?api_token=' + (user ? JSON.parse(user).api_token : ''),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(data),
        },
      )
        .then(res => res.json())
        .then(res => resolve(res));
    });
  },
};
export default Post;
